import React, { useState } from 'react';
import { Form, Modal } from 'antd';
import { useAppDispatch } from 'app/store';
import { TPreparedAbsenceSupervisor } from 'app/services/edpApiV1/supervisor/absenceSupervisor';

type TAbsenceModalProps = {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  id: string | undefined;
  absence?: TPreparedAbsenceSupervisor;
};

export const AbsenceModal = ({ openModal, setOpenModal, id, absence }: TAbsenceModalProps) => {
  const [modalText, setModalText] = useState<string>();
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();

  const handleOk = () => {};

  const handleCancel = () => {
    setOpenModal(false);
    setModalText('');
  };

  const onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    // если отсутствует текст, игнорирую пробелы и переносы строки клавищей "ENTER"
    if (!modalText) {
      setModalText(e.target.value.replace(/^\s+/g, ''));
    } else {
      setModalText(e.target.value);
    }
  };

  return (
    <Modal title="Информация о заявке" open={openModal} onCancel={handleCancel} footer={null}>
      <p>
        <span>Дата создания: </span>
        <span>{absence?.created}</span>
      </p>
      <p>
        <span>Комментарий: </span>
        <span>{absence?.comment}</span>
      </p>
    </Modal>
  );
};
